import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const TransactionLost = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.4595 11.5L7.31299 16.6465L8.0201 17.3536L13.1666 12.2071L18.3131 17.3536L19.0202 16.6465L13.8737 11.5L19.0201 6.35359L18.313 5.64648L13.1666 10.7929L8.02017 5.64648L7.31306 6.35359L12.4595 11.5Z"
      fill="currentColor"
    />
  </svg>,
  'TransactionLost'
);
